import { render, staticRenderFns } from "./RecordingState.vue?vue&type=template&id=c5b2c66a"
import script from "./RecordingState.vue?vue&type=script&lang=js"
export * from "./RecordingState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports